export class GlobalConstants {
  public static CAPTCHA_SITE_KEY = "6LemQn8UAAAAAEL3ZCDYKhr-JsJsTXDFWpuAF0bp";

  // Designer Studio - Secret
  public static DURABILITY_TYPE_TTL = "TTL";
  public static DURABILITY_TYPE_STATIC = "STATIC";

  public static DB_TYPES = [
    { label: "AccountFields", value: "ACCOUNT" },
    { label: "ApplicationFields", value: "APP" },
    { label: "LoanFields", value: "LOAN" },
    { label: "ShareFields", value: "SHARE" },
    { label: "Params", value: "PARAMS" },
  ];
}
